<template>
  <div :class="{'d-flex': !hasSlot}">
    <slot v-if="isPremium" />
    <div v-else class="d-flex" style="position:relative">
      <a to="/manage/billing" class="btn btn-link text-primary font-weight-bolder" @click="withPremium()">{{text}}</a>
      <!-- <div class="d-flex align-items-center justify-content-center">
        <div class="blur">
          <slot name="dummy">
            <slot />
          </slot>
        </div>
        <div
          class="h-100 align-items-center justify-content-center"
          :class="{'pro-overlay':hasSlot}"
        >
          <div class="text-center">
            <span class="badge badge-sm badge-warning p-1 px-2">Pro Feature</span>

            <small class="d-block">
              <a href="#" class>Upgrade now for patient information</a>
            </small>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    orWhen: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Upgrade for patient info',
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    isPremium() {
      return !this.user.practice.is_freemium || this.orWhen
    },
    hasSlot() {
      return !!this.$slots['default'] || !!this.$scopedSlots['default']
    },
  },
}
</script>

<style scoped>
.pro-overlay {
  position: absolute;
  top: 0px;
  /* background: #0000001a; */
}
.badge {
  border-radius: 10px;
}
</style>
